import { Action } from 'redux';

// driver account
export const GET_DRIVERATTRIBUTE = 'permit-fulfillment/GET_DRIVERATTRIBUTE';
export const getDriverAttribute = (data: any) => ({
  type: GET_DRIVERATTRIBUTE,
  payload: data,
});

export const SET_DRIVERATTRIBUTE = 'permit-fulfillment/SET_DRIVERATTRIBUTE';
export const setDriverAttribute = (data: ReadonlyArray<any>) => ({
  type: SET_DRIVERATTRIBUTE,
  payload: data,
});
export interface SetAttributeAction extends Action<typeof SET_DRIVERATTRIBUTE> {
  readonly payload: ReadonlyArray<any>;
}
// driver account end
// driver account bulk
export const GET_DRIVERACCOUNTBULK = 'permit-fulfillment/GET_DRIVERACCOUNTBULK';
export const getDriverAccountbulk = (data: any) => ({
  type: GET_DRIVERACCOUNTBULK,
  payload: data,
});

export const SET_DRIVERACCOUNT = 'permit-fulfillment/SET_DRIVERACCOUNT';
export const setDriverAccountbulk = (data: ReadonlyArray<any>) => ({
  type: SET_DRIVERACCOUNT,
  payload: data,
});
export interface SetaccountBulkAction extends Action<typeof SET_DRIVERACCOUNT> {
  readonly payload: ReadonlyArray<any>;
}
// driver account bulk

export const GET_FULFILLMENT_BATCHES = 'permit-fulfillment/GET_FULFILLMENT_BATCHES';
export const getPermitFulfillmentBatches = (data: SelectReportData) => ({
  type: GET_FULFILLMENT_BATCHES,
  payload: data,
});

export const SET_FULFILLMENT_BATCHES = 'permit-fulfillment/SET_FULFILLMENT_BATCHES';
export const setPermitFulfillmentBatches = (data: ReadonlyArray<PermitFulfillmentBatches>) => ({
  type: SET_FULFILLMENT_BATCHES,
  payload: data,
});
export interface SetFulfillmentBatchesAction extends Action<typeof SET_FULFILLMENT_BATCHES> {
  readonly payload: ReadonlyArray<PermitFulfillmentBatches>;
}

export const GET_COMPLETED_FULFILLMENTS = 'permit-fulfillment/GET_COMPLETED_FULFILLMENTS';
export const getCompletedFulfillments = (data: SelectReportData) => ({
  type: GET_COMPLETED_FULFILLMENTS,
  payload: data,
});

export const SET_COMPLETED_FULFILLMENTS = 'permit-fulfillment/SET_COMPLETED_FULFILLMENTS';
export const setCompledtedFulfillments = (data: ReadonlyArray<PermitCompletedFulfillments>) => ({
  type: SET_COMPLETED_FULFILLMENTS,
  payload: data,
});
export interface SetCompletedFulfillmentsAction extends Action<typeof SET_COMPLETED_FULFILLMENTS> {
  readonly payload: ReadonlyArray<PermitCompletedFulfillments>;
}

//pending fulfillments
export const GET_PENDING_FULFILLMENTS = 'permit-fulfillment/GET_PENDING_FULFILLMENTS';
export const getPendingFulfillments = (data: SelectReportData) => ({
  type: GET_PENDING_FULFILLMENTS,
  payload: data,
});
export const GET_PENDING_FULFILLMENTS_DATA = 'permit-fulfillment/GET_PENDING_FULFILLMENTS_DATA';
export const getPendingFulfillmentsData = (data: any) => ({
  type: GET_PENDING_FULFILLMENTS_DATA,
  payload: data,
});
export const SET_PENDING_FULFILLMENTS = 'permit-fulfillment/SET_PENDING_FULFILLMENTS';
export const setPendingFulfillments = (data: ReadonlyArray<PermitPendingFulfillments>) => ({
  type: SET_PENDING_FULFILLMENTS,
  payload: data,
});
export interface SetPendingFulfillmentsAction extends Action<typeof SET_PENDING_FULFILLMENTS> {
  readonly payload: ReadonlyArray<PermitPendingFulfillments>;
}
//pending fulfillments end

//reserve permit
export const GET_RESERVE_PERMIT = 'permit-fulfillment/GET_RESERVE_PERMIT';
export const getReservePermits = (data: any) => ({
  type: GET_RESERVE_PERMIT,
  payload: data,
});

export const SET_RESERVE_PERMIT = 'permit-fulfillment/SET_RESERVE_PERMIT';
export const setReservePermits = (data: ReadonlyArray<ReservePermitList>) => ({
  type: SET_RESERVE_PERMIT,
  payload: data,
});
export interface SetReservePermitAction extends Action<typeof SET_RESERVE_PERMIT> {
  readonly payload: ReadonlyArray<ReservePermitList>;
}
//reserve permit end

// reserve permit post
export const GET_POST_RESERVED_PERMIT = 'permit-fulfillment/GET_POST_RESERVED_PERMIT';
export const getPostReservedPermit = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_POST_RESERVED_PERMIT,
  payload: data,
});

// unreserved permit post
export const UNRESERVE_PERMIT = 'permit-fulfillment/UNRESERVE_PERMIT';
export const unreservePermit = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: UNRESERVE_PERMIT,
  payload: data,
});

export const SET_POST_RESERVED_PERMIT = 'permit-fulfillment/SET_POST_RESERVED_PERMIT';
export const setPostReservedPermit = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_POST_RESERVED_PERMIT,
  payload: data,
});

export interface ReservedPermitAction extends Action<typeof SET_POST_RESERVED_PERMIT>, OnCompleteAction {
  readonly payload: any;
}

//  Add Driver bulk account
export const GET_ADD_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/add-attribute-bulk';
export const getAddDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_ADD_DRIVER_BULK_ACCOUNT,
  payload: data,
});
export const SET_ADD_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/set-add-attribute-bulk';
export const setAddDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_ADD_DRIVER_BULK_ACCOUNT,
  payload: data,
});

export interface AddDriverBulkAccountAction extends Action<typeof SET_ADD_DRIVER_BULK_ACCOUNT>, OnCompleteAction {
  readonly payload: any;
}
//  Merge Driver bulk account
export const GET_MERGE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/GET_MERGE_DRIVER_BULK_ACCOUNT';
export const getMergeDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_MERGE_DRIVER_BULK_ACCOUNT,
  payload: data,
});
export const SET_MERGE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/SET_MERGE_DRIVER_BULK_ACCOUNT';
export const setMergeDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_MERGE_DRIVER_BULK_ACCOUNT,
  payload: data,
});

export interface MergeDriverBulkAccountAction extends Action<typeof SET_MERGE_DRIVER_BULK_ACCOUNT>, OnCompleteAction {
  readonly payload: any;
}

//  Delete Driver bulk account
export const GET_DELETE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/eua/get-delete-bulk-drivers';
export const getDeleteDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_DELETE_DRIVER_BULK_ACCOUNT,
  payload: data,
});
export const SET_DELETE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/eua/set-delete-bulk-drivers';
export const setDeleteDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_DELETE_DRIVER_BULK_ACCOUNT,
  payload: data,
});

export interface DeleteDriverBulkAccountAction extends Action<typeof SET_DELETE_DRIVER_BULK_ACCOUNT>, OnCompleteAction {
  readonly payload: any;
}
//  Delete Driver attribute  bulk account
export const GET_DELETE_ATRRRIBUTE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/eua/get-delete-attribute-bulk';
export const getDeleteAttributeDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_DELETE_ATRRRIBUTE_DRIVER_BULK_ACCOUNT,
  payload: data,
});
export const SET_DELETE_ATTRIBUTE_DRIVER_BULK_ACCOUNT = 'permit-fulfillment/bulk/eua/set-delete-attribute-bulk';
export const setDeleteAttributeDriverBulkAccount = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_DELETE_ATTRIBUTE_DRIVER_BULK_ACCOUNT,
  payload: data,
});

export interface DeleteAttributeDriverBulkAccountAction
  extends Action<typeof SET_DELETE_ATTRIBUTE_DRIVER_BULK_ACCOUNT>, OnCompleteAction {
  readonly payload: any;
}

// single  reserve permit post
export const SINGLE_GET_POST_RESERVED_PERMIT = 'permit-fulfillment/SINGLE_GET_POST_RESERVED_PERMIT';
export const singleGetPostReservedPermit = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SINGLE_GET_POST_RESERVED_PERMIT,
  payload: data,
});
export const SINGLE_SET_POST_RESERVED_PERMIT = 'permit-fulfillment/SINGLE_SET_POST_RESERVED_PERMIT';
export const singleSetPostReservedPermit = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SINGLE_SET_POST_RESERVED_PERMIT,
  payload: data,
});

export interface SingleReservedPermitAction extends Action<typeof SINGLE_SET_POST_RESERVED_PERMIT>, OnCompleteAction {
  readonly payload: any;
}

// reserve permit post-end

// single batch created
export const GET_SINGLE_BATCH_CREATED = 'permit-fulfillment/GET_SINGLE_BATCH_CREATED';
export const getSingleBatchCreates = (
  data: FulfillmentsProcessBatchMultipleClientsFormValues,
  onComplete?: () => void,
) => ({
  meta: {
    onComplete,
  },
  type: GET_SINGLE_BATCH_CREATED,
  payload: data,
});

export const SET_SINGLE_BATCH_CREATED = 'permit-fulfillment/SET_SINGLE_BATCH_CREATED';
export const setSingleBatchCreates = (
  data: FulfillmentsProcessBatchMultipleClientsFormValues | undefined,
  onComplete?: () => void,
) => ({
  meta: {
    onComplete,
  },
  type: SET_SINGLE_BATCH_CREATED,
  payload: data,
});
export interface SingleBatchCreatedAction extends Action<typeof SET_SINGLE_BATCH_CREATED>, OnCompleteAction {
  readonly payload: FulfillmentsProcessBatchMultipleClientsFormValues | undefined;
}
// single batch created-end

export const PRINT_FULFILLMENT_BATCH = 'permit-fulfillment/PRINT_FULFILLMENT_BATCH';
export const printfulfillmentBatch = (data: any) => ({
  type: PRINT_FULFILLMENT_BATCH,
  payload: data,
});
export const SET_PRINT_FULFILLMENT_BATCH = 'permit-fulfillment/SET_PRINT_FULFILLMENT_BATCH';
export const setPrintfulfillmentBatch = (data: any) => ({
  type: PRINT_FULFILLMENT_BATCH,
  payload: data,
});
export interface SetPrintBatchAction extends Action<typeof SET_PRINT_FULFILLMENT_BATCH> {
  readonly payload: ReadonlyArray<any>;
}

export const PRINT_FULFILLMENT_LETTERS = 'permit-fulfillment/PRINT_FULFILLMENT_LETTERS';
export const printfulfillmentLetters = (data: any) => ({
  type: PRINT_FULFILLMENT_LETTERS,
  payload: data,
});
export const SET_PRINT_FULFILLMENT_LETTERS = 'permit-fulfillment/SET_PRINT_FULFILLMENT_LETTERS';
export const setPrintfulfillmenLetters = (data: any) => ({
  type: SET_PRINT_FULFILLMENT_LETTERS,
  payload: data,
});
export interface SetPrintFulfillmentsAction extends Action<typeof SET_PRINT_FULFILLMENT_LETTERS> {
  readonly payload: ReadonlyArray<any>;
}
// issue temporary permit
export const ISSUE_TEMPORARY_PERMITS = 'permit-fulfillment/ISSUE_TEMPORARY_PERMITS';
export const issueTemporaryPermits = (data: any) => ({
  type: ISSUE_TEMPORARY_PERMITS,
  payload: data,
});
export const SET_ISSUE_TEMPORARY_PERMITS = 'permit-fulfillment/SET_ISSUE_TEMPORARY_PERMITS';
export const setIssueTemporaryPermits = (data: any) => ({
  type: SET_ISSUE_TEMPORARY_PERMITS,
  payload: data,
});
export interface SetTemporaryPermitsAction extends Action<typeof SET_ISSUE_TEMPORARY_PERMITS> {
  readonly payload: ReadonlyArray<any>;
}

export const ISSUE_TEMPORARY_PERMITS_WITH_ID_OPEN = 'permit-fulfillment/ISSUE_TEMPORARY_PERMITS_WITH_ID_OPEN';
export const issueTemporaryPermitsWithOpen = () => {
  return {
    type: ISSUE_TEMPORARY_PERMITS_WITH_ID_OPEN,
  };
};
export interface IssueTemporaryPermitsWithOpenAction extends Action<typeof ISSUE_TEMPORARY_PERMITS_WITH_ID_OPEN> {}

export const ISSUE_TEMPORARY_PERMITS_WITH_ID_CLOSE = 'permit-fulfillment/ISSUE_TEMPORARY_PERMITS_WITH_ID_CLOSE';
export const issueTemporaryPermitsWithClose = () => {
  return {
    type: ISSUE_TEMPORARY_PERMITS_WITH_ID_CLOSE,
  };
};
export interface IssueTemporaryPermitsWithCloseAction extends Action<typeof ISSUE_TEMPORARY_PERMITS_WITH_ID_CLOSE> {}

// unknow citaiton  open

export const ISSUE_UNKNOWN_CITATION_OPEN = 'permit-fulfillment/ISSUE_UNKNOWN_CITATION_OPEN';
export const issueUnknownCitationOpen = () => {
  return {
    type: ISSUE_UNKNOWN_CITATION_OPEN,
  };
};
export interface IssueUnknownCitationOpenAction extends Action<typeof ISSUE_UNKNOWN_CITATION_OPEN> {}

export const ISSUE_UNKNOWN_CITATION_CLOSE = 'permit-fulfillment/ISSUE_UNKNOWN_CITATION_CLOSE';
export const issueUnknownCitationClose = () => {
  return {
    type: ISSUE_UNKNOWN_CITATION_CLOSE,
  };
};
export interface IssueUnknownCitationCloseAction extends Action<typeof ISSUE_UNKNOWN_CITATION_CLOSE> {}

// unknow citaiton  open end

export const ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_OPEN = 'permit-fulfillment/ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_OPEN';
export const issueTemporaryPermitsWithoutOpen = () => {
  return {
    type: ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_OPEN,
  };
};

export interface IssueTemporaryPermitsWithoutOpenAction extends Action<
  typeof ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_OPEN
> {}

export const ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_CLOSE = 'permit-fulfillment/ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_CLOSE';
export const issueTemporaryPermitsWithoutClose = () => {
  return {
    type: ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_CLOSE,
  };
};
export interface IssueTemporaryPermitsWithoutCloseAction extends Action<
  typeof ISSUE_TEMPORARY_PERMITS_WITHOUT_ID_CLOSE
> {}
// issue temporary permit  end

// viw recbtch  start
export const VIEW_RECON_BTCH_OPEN = 'permit-fulfillment/VIEW_RECON_BTCH_OPEN';
export const viewRecnBtchOpen = () => {
  return {
    type: VIEW_RECON_BTCH_OPEN,
  };
};

export interface ViewRecnBtchOpenAction extends Action<typeof VIEW_RECON_BTCH_OPEN> {}

export const VIEW_RECON_BTCH_CLOSE = 'permit-fulfillment/VIEW_RECON_BTCH_CLOSE';
export const viewRecnBtchClose = () => {
  return {
    type: VIEW_RECON_BTCH_CLOSE,
  };
};
export interface ViewRecnBtchCloseAction extends Action<typeof VIEW_RECON_BTCH_CLOSE> {}
//  viw recbtch   end

// create issue with temporary permit
export const GET_CREATE_PERMIT_WITH_ID = 'permit-fulfillment/GET_CREATE_PERMIT_WITH_ID';
export const getCreatePermitWithID = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_CREATE_PERMIT_WITH_ID,
  payload: data,
});
export const SET_CREATE_PERMIT_WITH_ID = 'permit-fulfillment/SET_CREATE_PERMIT_WITH_ID';
export const setCreatePermitWithID = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_CREATE_PERMIT_WITH_ID,
  payload: data,
});

export interface CreatePermitWithIDAction extends Action<typeof SET_CREATE_PERMIT_WITH_ID>, OnCompleteAction {
  readonly payload: any;
}
export const GET_PERMIT_WITH_ID = 'permit-fulfillment/GET_PERMIT_WITH_ID';
export const getPermitWithID = (data: SelectReportData) => ({
  type: GET_PERMIT_WITH_ID,
  payload: data,
});

export const SET_PERMIT_WITH_ID = 'permit-fulfillment/SET_PERMIT_WITH_ID';
export const PermitWithID = (data: ReadonlyArray<PermitPendingFulfillments>) => ({
  type: SET_PERMIT_WITH_ID,
  payload: data,
});

export const SET_ERROR_MESSAGE_PERMIT = 'permit-fulfillment/SET_ERROR_MESSAGE_PERMIT';
export const setErrorMessagePermit = (data: any) => ({
  type: SET_ERROR_MESSAGE_PERMIT,
  payload: data,
});
export interface SetErrorMessagePermitAction extends Action<typeof SET_ERROR_MESSAGE_PERMIT> {
  readonly payload: ReadonlyArray<any>;
}

export interface SetPermitWithIDAction extends Action<typeof SET_PERMIT_WITH_ID> {
  readonly payload: ReadonlyArray<PermitPendingFulfillments>;
}
// get View Reconcilaiton batch api
export const SUPER_GET_VIEW_RECONCILAITON_BTCH = 'permit-fulfillment/SUPER_GET_VIEW_RECONCILAITON_BTCH';
export const getSuperReconBtch = (data: any) => ({
  type: SUPER_GET_VIEW_RECONCILAITON_BTCH,
  payload: data,
});

export const SUPER_SET_VIEW_RECONCILAITON_BTCH = 'permit-fulfillment/SUPER_SET_VIEW_RECONCILAITON_BTCH';
export const setSuperReconBtch = (data: any) => ({
  type: SUPER_SET_VIEW_RECONCILAITON_BTCH,
  payload: data,
});

export interface SuperReconBtchAction extends Action<typeof SUPER_SET_VIEW_RECONCILAITON_BTCH> {
  payload: ReadonlyArray<any>;
}
// tax rate
export const GET_TAX_RATE = 'permit-fulfillment/GET_TAX_RATE';
export const getTaxRate = () => ({
  type: GET_TAX_RATE,
});

export const SET_TAX_RATE = 'permit-fulfillment/SET_TAX_RATE';
export const setTaxRate = (data: ReadonlyArray<any>) => ({
  type: SET_TAX_RATE,
  payload: data,
});
export interface SetTaxRateAction extends Action<typeof SET_TAX_RATE> {
  readonly payload: ReadonlyArray<any>;
}
// tax rate end
export type PermitFulfillmentBatchesAction =
  | SetFulfillmentBatchesAction
  | SetCompletedFulfillmentsAction
  | SetPendingFulfillmentsAction
  | SetReservePermitAction
  | ReservedPermitAction
  | SetPrintBatchAction
  | SingleBatchCreatedAction
  | CreatePermitWithIDAction
  | SetPermitWithIDAction
  | SetPrintFulfillmentsAction
  | SingleReservedPermitAction
  | SetTemporaryPermitsAction
  | SetErrorMessagePermitAction
  | IssueTemporaryPermitsWithOpenAction
  | IssueTemporaryPermitsWithCloseAction
  | IssueTemporaryPermitsWithoutOpenAction
  | IssueTemporaryPermitsWithoutCloseAction
  | SuperReconBtchAction
  | ViewRecnBtchOpenAction
  | IssueUnknownCitationOpenAction
  | IssueUnknownCitationCloseAction
  | ViewRecnBtchCloseAction
  | SetAttributeAction
  | SetaccountBulkAction
  | SetTaxRateAction
  | AddDriverBulkAccountAction
  | MergeDriverBulkAccountAction
  | DeleteDriverBulkAccountAction
  | DeleteAttributeDriverBulkAccountAction;
